<template>
  <el-popover
    trigger="click"
    ref="keywordPicker"
    placement="bottom-start"
    @show="handlePopoverShow"
    :visible-arrow="false">
    <div class="app-keyword-picker">
      <div class="app-keyword-picker__header">
        <h4 class="app-keyword-picker__title">选择关键词</h4>
      </div>
      <div class="app-keyword-picker__body">
        <div class="app-keyword-picker__left">
          <div class="app-keyword-picker__box" style="width: 48%;">
            <div class="app-keyword-picker__box__header">
              <h5 class="app-keyword-picker__subtitle">关键词类型</h5>
            </div>
            <div class="app-keyword-picker__box__body">
              <ul class="app-keyword-picker__keyword">
                <template v-for="item in categories">
                  <li
                    class="app-keyword-picker__keyword__item"
                    :class="{ 'app-keyword-picker__keyword__item--active': category.id === item.id }"
                    @click="handleCategoryChange(item)"
                    :key="item.id">
                    {{ item.label }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="app-keyword-picker__box" style="width: 48%;">
            <div class="app-keyword-picker__box__header">
              <el-input
                v-model="category.query"
                @input="handleSearchInputChange"
                placeholder="请输入关键词"
                size="mini">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="app-keyword-picker__box__body">
              <ul class="app-keyword-picker__keyword">
                <template v-for="item in category.keywords">
                  <li
                    class="app-keyword-picker__keyword__item"
                    :class="{ 'app-keyword-picker__keyword__item--active': indexOf(item) > -1 }"
                    @click="handleKeywordSelect(item)"
                    :key="item.keywordTypeId + item.keyword">
                    {{ item.keyword }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="app-keyword-picker__middle">
          <!-- <div><i class="el-icon-arrow-left"></i></div> -->
          <div style="margin-top: 10px;"><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="app-keyword-picker__right">
          <div class="app-keyword-picker__box" style="width: 100%;">
            <div class="app-keyword-picker__box__header">
              <h5 class="app-keyword-picker__subtitle">已选中关键词</h5>
            </div>
            <div class="app-keyword-picker__box__body">
              <ul class="app-keyword-picker__keyword">
                <li class="app-keyword-picker__keyword__item app-keyword-picker__keyword__item--nopointer"
                  v-for="item in selected"
                  :key="item.key">
                  <span class="app-keyword-picker__keyword__item__text">{{ item.keyword }}</span>
                  <i class="el-icon-circle-close" @click="handleKeywordRemove(item)"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="app-keyword-picker__footer">
        <div class="app-keyword-picker__message"></div>
        <div class="app-keyword-picker__operation">
          <el-button type="default" @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleOk">确定</el-button>
        </div>
      </div>
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import api from '@/api'

export default {
  name: 'AppKeywordPicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      category: {
        query: '',
        keywords: []
      },
      categories: [],
      selected: this.copySelected(this.value)
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    }
  },

  watch: {
    categories (newValue, oldValue) {
      if (newValue.length > 0) {
        this.handleCategoryChange(newValue[0])
      }
    },
    value (newValue, oldValue) {
      this.selected = this.copySelected(newValue)
    }
  },

  methods: {
    getKeywordPackages () {
      api.keyword.getKeywordPackages({
        params: { userId: this.user.id }
      }).then(response => {
        const { data: { keywordPackageList } } = response
        this.categories = keywordPackageList.map(item => ({
          id: item.id,
          type: item.type,
          label: item.name,
          query: '',
          keywords: []
        }))
      })
    },

    getKeywordsByQuery (category) {
      api.keyword.getKeywordSuggest({
        params: { userId: this.user.id },
        query: {
          keywordPackageId: category.id,
          query: category.query,
          offset: 0,
          limit: 15
        }
      }).then(response => {
        const { data: { keywords } } = response
        category.keywords = keywords.map(keyword => ({
          keyword,
          keywordTypeId: category.type,
          keywordPackageInfo: { id: category.id }
        }))
      })
    },

    copySelected (list) {
      const arr = []

      list.forEach(item => {
        arr.push({
          keywordTypeId: item.keywordTypeId,
          keyword: item.keyword,
          keywordPackageInfo: {
            id: item.keywordPackageInfo.id
          }
        })
      })

      return arr
    },

    isEquel (keyword1, keyword2) {
      if (
        keyword1.keyword === keyword2.keyword &&
        keyword1.keywordTypeId === keyword2.keywordTypeId &&
        keyword1.keywordPackageInfo.id === keyword2.keywordPackageInfo.id
      ) {
        return true
      }

      return false
    },

    indexOf (keyword) {
      for (let i = 0; i < this.selected.length; i++) {
        const item = this.selected[i]
        if (this.isEquel(item, keyword)) {
          return i
        }
      }

      return -1
    },

    handlePopoverShow () {
      this.getKeywordPackages()
    },

    handleCategoryChange (category) {
      this.category = category
      if (category.keywords.length === 0) {
        this.getKeywordsByQuery(category)
      }
    },

    handleSearchInputChange () {
      this.getKeywordsByQuery(this.category)
    },

    handleKeywordSelect (keyword) {
      if (this.indexOf(keyword) > -1) return
      if (this.multiple) {
        this.selected.push(keyword)
      } else {
        this.selected = [ keyword ]
      }
    },

    handleKeywordRemove (keyword) {
      const index = this.indexOf(keyword)
      if (index < 0) return
      if (this.multiple) {
        this.selected.splice(index, 1)
      } else {
        this.selected = []
      }
    },

    close () {
      this.$refs.keywordPicker.doClose()
    },

    handleCancel () {
      this.close()
    },

    handleOk () {
      this.close()
      this.$emit('ok', this.selected)
    }

  }
}
</script>

<style lang="scss">
.app-keyword-picker {
  width: 750px;
  background-color: #fff;

  .el-input__icon {
    width: 25px;
    line-height: 32px;
  }

  &__header {
    padding: 10px 15px;
    margin: -12px -12px 0;
    background-color: #f3f3f3;
  }

  &__body {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    margin: 0 -12px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    margin: 0 -12px -12px;
    border-top: 1px solid $border-color;
  }

  &__title {
    margin: 0;
    font-size: 14px;
  }

  &__subtitle {
    margin: 0;
    font-size: 14px;
  }

  &__left {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }

  &__middle {
    padding: 0 12px;
  }

  &__right {
    width: 230px;
  }

  &__box {
    border: 1px solid $border-color;

    &__header {
      height: 40px;
      line-height: 39px;
      padding: 0 10px;
      border-bottom: 1px solid $border-color;
    }

    &__body {
      height: 245px;
      overflow: auto;
    }
  }

  &__keyword {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2px 12px;
      margin: 5px 0;

      &:hover,
      &--active {
        background-color: #f3f3f3;
        color: $primary-color;
        cursor: pointer;
      }

      &__text {
        padding-right: 10px;
      }
    }
  }
}
</style>
